'use client'

import {Award, Project, Project1} from '@/(payload)/payload-types'
import SplashCursor               from '@/app/(frontend)/[lang]/SplashCursor'
import ProjectsAwwards            from '@/components/projects/ProjectsAwwards'
import ProjectsList               from '@/components/projects/ProjectsList'
import cn                         from 'classnames'
import {PaginatedDocs}            from 'payload'
import React                      from 'react'
import styles                     from './page.module.sass'

type Props = {
	page:        Project1
	projects:    PaginatedDocs<Project>
	awards:      PaginatedDocs<Award>
	awardsTitle: string
}

const ProjectsPage = ({
	page,
	projects,
	awards,
	awardsTitle,
}: Props) => {
	return (<main className={styles[`projects-main`]}>
		<SplashCursor/>

		<h1 className={styles['projects-title']}>{page.title}</h1>

		<ProjectsList
			data={projects}
			className={cn(styles['projects-list'], 'js-section js-floating-menu-light')}
			nbImagesWithHighPriority={2}
		/>

		<ProjectsAwwards
			title={awardsTitle}
			data={awards.docs}
		/>
	</main>)
}
export default ProjectsPage
